import { message } from 'antd';
import { Component } from 'react';
import { WebNotifications } from '../../../../web-notifications';
import { CompanyName } from './CompanyNameComponent.jsx';
import { Menu } from './MenuComponent.jsx';
import ElevatedPermissionsToggle from 'src/_shared/components/elevated-permissions/ElevatedPermissionsToggle.jsx';

class UserProfile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentUser: props.currentUser,
		};
	}

	onSelectLanguage = async (countryCode) => {
		const { onUpdate, updateCurrentUserLanguage } = this.props;
		onUpdate({
			input: {
				id: this.state.currentUser.id,
				languageCode: countryCode,
			},
		});
		const updatedCurrentUser = {
			...this.state.currentUser,
			languageCode: countryCode,
		};
		await updateCurrentUserLanguage(updatedCurrentUser);
		message.success('Language set successfully');
	};

	render() {
		const {
			currentUser,
			allMultiLingualData,
			toggleAdminControls,
			showAdminControls,
		} = this.props;

		const functions = {
			onSelectLanguage: this.onSelectLanguage,
		};

		return (
			<div
				className="header-right"
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					width: '256px',
					background: 'white',
					marginRight: '15px',
					marginLeft: 'auto',
				}}
			>
				<ElevatedPermissionsToggle
					toggleAdminControls={toggleAdminControls}
					showAdminControls={showAdminControls}
					currentUser={currentUser}
				/>

				<WebNotifications currentUser={currentUser} />
				<CompanyName currentUser={currentUser} />
				<Menu
					currentUser={currentUser}
					allMultiLingualData={allMultiLingualData}
					functions={functions}
				/>
			</div>
		);
	}
}

export default UserProfile;
